import {
  type QueryOptions,
  useQuery,
  type UseQueryResult,
} from '@tanstack/react-query';
import { z } from 'zod';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';

export const gradeResponseShape = z.array(
  z.object({
    country: z.string(),
    id: z.string(),
    grade_code: z.string(),
    grade_name: z.string(),
    sequence_num: z.number(),
  })
);

export type Grade = z.infer<typeof gradeResponseShape>[0];

export async function getGrades(country: string): Promise<Grade[]> {
  const grades = await fetcher(`/grades/countries/${country}`, {
    service: '/roster',
    version: '/v2',
  });

  return gradeResponseShape.parse(grades);
}

export const getGradesApiQueryKey = (country?: string) =>
  ['/v2', 'grades', country].filter(Boolean) as string[];

export function useGetGradesApi(
  country = 'USA',
  customQueryOptions?: QueryOptions<Grade[], ApiError>
): UseQueryResult<Grade[], ApiError> {
  return useQuery({
    queryKey: getGradesApiQueryKey(country),
    queryFn: () => getGrades(country),
    select: (grades) => grades.sort((a, b) => a.sequence_num - b.sequence_num),
    staleTime: Infinity,
    ...customQueryOptions,
  });
}
